// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const FiveStarsOrange = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 136 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="m12 0 2.694 8.292h8.719l-7.054 5.124 2.694 8.292L12 16.584l-7.053 5.124 2.694-8.292L.587 8.292h8.719L12 0Z"
			fill="url(#FiveStarsOrange_tsx__a)"
		/>
		<path
			d="m40 0 2.694 8.292h8.719l-7.054 5.124 2.694 8.292L40 16.584l-7.053 5.124 2.694-8.292-7.054-5.124h8.719L40 0Z"
			fill="url(#FiveStarsOrange_tsx__b)"
		/>
		<path
			d="m68 0 2.694 8.292h8.719l-7.054 5.124 2.694 8.292L68 16.584l-7.053 5.124 2.694-8.292-7.054-5.124h8.719L68 0Z"
			fill="url(#FiveStarsOrange_tsx__c)"
		/>
		<path
			d="m96 0 2.694 8.292h8.719l-7.054 5.124 2.694 8.292L96 16.584l-7.053 5.124 2.694-8.292-7.054-5.124h8.719L96 0Z"
			fill="url(#FiveStarsOrange_tsx__d)"
		/>
		<path
			d="m124 0 2.694 8.292h8.719l-7.054 5.124 2.694 8.292L124 16.584l-7.053 5.124 2.694-8.292-7.054-5.124h8.719L124 0Z"
			fill="url(#FiveStarsOrange_tsx__e)"
		/>
		<defs>
			<linearGradient
				id="FiveStarsOrange_tsx__a"
				x1={0}
				y1={0}
				x2={24}
				y2={24}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FFC52B" />
				<stop offset={1} stopColor="#FF8B3A" />
			</linearGradient>
			<linearGradient
				id="FiveStarsOrange_tsx__b"
				x1={28}
				y1={0}
				x2={52}
				y2={24}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FFC52B" />
				<stop offset={1} stopColor="#FF8B3A" />
			</linearGradient>
			<linearGradient
				id="FiveStarsOrange_tsx__c"
				x1={56}
				y1={0}
				x2={80}
				y2={24}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FFC52B" />
				<stop offset={1} stopColor="#FF8B3A" />
			</linearGradient>
			<linearGradient
				id="FiveStarsOrange_tsx__d"
				x1={84}
				y1={0}
				x2={108}
				y2={24}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FFC52B" />
				<stop offset={1} stopColor="#FF8B3A" />
			</linearGradient>
			<linearGradient
				id="FiveStarsOrange_tsx__e"
				x1={112}
				y1={0}
				x2={136}
				y2={24}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FFC52B" />
				<stop offset={1} stopColor="#FF8B3A" />
			</linearGradient>
		</defs>
	</svg>
);
export default FiveStarsOrange;
